module.exports = __webpack_public_path__ + "static/media/panificacion_pandecaja.7865547d.jpg";